export default "__VITE_ASSET__DblKb2k5__"